import { Box, Button, Grid } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const StrategicAlliances = () => {
  const handleDuran = (e) => {
    e.preventDefault();
    const mensaje =
      "Hola Laboratorio Clinico Duran, me interesaria saber mas sobre sus servios 🏥👋";

    trackEvent("whatsapp_servicios_Duran", {
      page_path: window.location.pathname,
      page_url: window.location.href,
      section: "servicios_Duran",
      label: "Servicios Duran",
      cta_name: "enviar_whatsapp",
      message_type: "contacto_general",
      value: 1,
    });

    openWhatsApp("5951255391", mensaje, false);
  };

  const handleMovi = (e) => {
    e.preventDefault();
    const mensaje =
      "Hola MoviCare, me interesaria saber mas sobre sus servios 🏥👋";

    trackEvent("whatsapp_servicios_MoviCare", {
      page_path: window.location.pathname,
      page_url: window.location.href,
      section: "servicios_MoviCare",
      label: "Servicios MoviCare",
      cta_name: "enviar_whatsapp",
      message_type: "contacto_general",
      value: 1,
    });

    openWhatsApp("5514772163", mensaje, false);
  };
  return (
    <Grid container sx={design.Container}>
      <Grid size={{ xs: 1, md: 1, xl: 1.5 }} />

      <Grid size={{ xs: 10, md: 10, xl: 9 }} py={2}>
        <CustomText
          color="#215DA6"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          width="100%"
          sx={design.Title}
        >
          Nuestras Alianzas
        </CustomText>
        <Box sx={design.Line} />
        <Grid container spacing={5} mt={2} mb={8}>
          {/* CARD IZQUIERDA */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={design.Card("#00518c", "#b0c9db8b")}>
              <Box sx={design.Header}>
                <Box flex={1} sx={design.align}>
                  <ImageLoader
                    src="https://dulab.com.mx/assets/dulab-logo-sUMgtMu4.png"
                    // width="100%"
                    height={78}
                    style={{
                      maxWidth: { xs: 200, md: 240 },
                      height: "auto",
                    }}
                  />
                </Box>
                <Box sx={design.BadgeLab}>Laboratorio</Box>
              </Box>
              <CustomText
                color="#000"
                fontWeight={400}
                fontFamily="Nunito"
                textAlign="justify"
                width="99%"
                sx={design.Description}
              >
                Nos aliamos con uno de los laboratorios más prestigiosos del
                país para garantizar diagnósticos confiables respaldados por
                tecnología de vanguardia y un equipo altamente capacitado.
              </CustomText>
              <CustomText
                color="#8893A5"
                fontWeight={500}
                fontFamily="Nunito"
                textAlign="left"
                width="100%"
                style={design.SectionTitle}
              >
                SERVICIOS EN MEDAM
              </CustomText>
              <Grid container spacing={1} mt={2}>
                <Grid size={6}>
                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Laboratorio 24h
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Tomografía
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Mastografía
                    </CustomText>
                  </Box>
                </Grid>

                <Grid size={6}>
                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Rayos X
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Ultrasonido
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Resonancia
                    </CustomText>
                  </Box>
                </Grid>
              </Grid>
              <Box sx={design.AlignBtom}>
                <Button
                  variant="contained"
                  href={handleDuran}
                  target="_blank"
                  sx={design.GoogleButton("#00518c")}
                >
                  Cotizar mi orden
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* CARD DERECHA */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={design.Card("#35b32e", "#47903c4f")}>
              <Box sx={design.Header}>
                <Box flex={1} sx={design.align}>
                  <ImageLoader
                    src="https://dulab.com.mx/assets/MoviCare-C4zsWL9o.png"
                    height={70}
                    style={{
                      maxWidth: { xs: 200, md: 310 },
                      height: "auto",
                    }}
                  />
                </Box>
                <Box sx={design.BadgeDom}>Domicilio</Box>
              </Box>
              <CustomText
                color="#000"
                fontWeight={400}
                fontFamily="Nunito"
                textAlign="justify"
                width="100%"
                sx={design.Description}
              >
                Nuestra alianza extiende la atención médica integral hasta la
                puerta de tu casa, facilitando servicios dignos y accesibles con
                la misma visión de excelencia que nos caracteriza.
              </CustomText>
              <CustomText
                color="#8893A5"
                fontWeight={500}
                fontFamily="Nunito"
                textAlign="left"
                width="100%"
                style={design.SectionTitle}
              >
                ATENCIÓN ESPECIALIZADA
              </CustomText>
              <Grid container>
                <Grid size={{ xs: 10, md: 8, xl: 8 }}>
                  <Box sx={design.CheckItem}>
                    <CheckRoundedIcon sx={design.CheckIcon} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Estudios de laboratorio clínico a domicilio
                    </CustomText>
                  </Box>
                  <Box sx={design.CheckItem}>
                    <CheckRoundedIcon sx={design.CheckIcon} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Servicios de Rayos X en casa
                    </CustomText>
                  </Box>
                  <Box sx={design.CheckItem}>
                    <CheckRoundedIcon sx={design.CheckIcon} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Traslados en ambulancia equipada
                    </CustomText>
                  </Box>
                  <Box sx={design.CheckItem}>
                    <CheckRoundedIcon sx={design.CheckIcon} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Atención exclusiva para pacientes con movilidad reducida
                    </CustomText>
                  </Box>
                </Grid>
                <Grid size={{ xs: 10, md: 4, xl: 4 }}>
                  <Box sx={design.CardResul}>
                    <ImageLoader
                      src="https://centromedicomedam.com/IMG/centromedicoMEDAM/PDF.svg"
                      width={30}
                    />
                    <CustomText
                      color="#1E293B"
                      fontWeight={800}
                      fontFamily="Nunito"
                      sx={design.TextResul}
                    >
                      Resultados Digitales
                    </CustomText>
                  </Box>
                </Grid>
              </Grid>
              <Box sx={design.AlignBtom}>
                <Button
                  variant="contained"
                  href={handleMovi}
                  target="_blank"
                  sx={design.GoogleButton("#35b32e")}
                >
                  Cotizar mi orden
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ xs: 1, md: 1.5 }} />
    </Grid>
  );
};

export default StrategicAlliances;

const design = {
  Container: {
    background: "#FFFFFF",
  },
  Title: {
    fontSize: { xs: 34, md: 46 },
    mt: 1,
  },
  Line: {
    width: 70,
    height: 4,
    background: "#0A56D8",
    borderRadius: 10,
    mx: "auto",
  },
  Card: (color, boxS) => ({
    background: "#FFF",
    borderRadius: "20px",
    padding: { xs: "16px", sm: "20px" },
    boxSizing: "border-box",
    height: "100%",
    minHeight: { xs: "auto", md: 390 },
    transition: ".35s",
    border: `1px solid ${color}`,
    "&:hover": {
      border: `1px solid ${color}`,
      transform: "translateY(-5px)",
      boxShadow: `20px 20px 35px 0px ${boxS}`,
    },
  }),
  align: {
    display: "flex",
    justifyContent: "flex-start",
  },
  Header: {
    display: "flex",
    alignItems: "center",
    mb: 3,
  },
  Font: {
    fontSize: 13,
  },
  BadgeDom: {
    borderRadius: "30px",
    padding: "5px 14px",
    fontWeight: 700,
    fontSize: 14,
    fontFamily: "Nunito",
    color: "#63b32e",
    background: "#EAFBF2",
  },
  BadgeLab: {
    borderRadius: "30px",
    padding: "5px 14px",
    fontWeight: 700,
    fontSize: 14,
    color: "#00579c",
    background: "#EEF4FF",
    fontFamily: "Nunito",
  },
  Description: {
    lineHeight: { xs: "normal", md: 1.8 },
    fontSize: 15,
    mb: 2,
  },
  SectionTitle: {
    fontSize: 12,
    letterSpacing: "2px",
  },
  Service: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 1.5,
    fontSize: 15,
  },
  Dot: {
    fontSize: 8,
    color: "#00579c",
  },
  CheckItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
    mb: 1,
    mt: 1,
  },
  CheckIcon: {
    color: "#63b32e",
    fontSize: 18,
    mt: "2px",
  },
  AlignBtom: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 3,
  },
  GoogleButton: (color) => ({
    width: { xs: "80%", md: "40%" },
    height: 45,
    borderRadius: "16px",
    textTransform: "none",
    fontFamily: "Nunito",
    fontWeight: 800,
    fontSize: 15,
    background: color,
    transition: ".35s",
    "&:hover": {
      background: color,
      transform: "translateY(-2px)",
    },
    gap: 1,
    marginTop: 1,
  }),
  CardResul: {
    width: "90%",
    minHeight: 50,
    borderRadius: "14px",
    background: "#F7FFFA",
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    flexDirection: "column",
    gap: 1.5,
    padding: "19px 12px",
    ml: 1,
  },
  TextResul: {
    fontSize: 13,
    lineHeight: 1.2,
    mb: 0.3,
  },
};
